<button class="button-collapse p-0 border-0 shadow bg-white rounded-circle" (click)="clickCollapse()">
  <i class="icon-24 font-size-24 font-weight-bolder pb-1"
     [ngClass]="menuCollapsed? 'se-icon-arrow2_left' : 'se-icon-arrow2_right'"
  ></i>
</button>
